<template>
  <div>
    <!-- <rotate-square2></rotate-square2> -->
    <div class="w-full  ">
      <div class="md:flex text-center md:justify-between">
        <div
          class="text-custom text-xl lg:text-2xl mb-5 md:mb-0 leading-none font-medium"
        >
          Tickets
        </div>
        <router-link
          class="btn ml-auto py-1 px-5 text-white font-medium hover:text-black"
          to="/user/ticket/new"
          >New Ticket</router-link
        >
      </div>

      <!-- component -->
      <div class="py-8">
        <div class="shadow overflow-y-hidden rounded-lg">
          <!-- <vue-good-table
            :columns="columns"
            :rows="rows"
            mode="remote"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            max-height="200px"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              mode: 'records'
            }"
            :totalRows="totalTickets"
            :fixed-header="true"
          >
            <div slot="emptystate" class="center">
              No Tickets found
            </div>
          </vue-good-table> -->

          <table class="table-auto w-full" id="tickets-table">
            <thead class="bg-custom text-white">
              <tr>
                <th>No</th>
                <th>Title</th>
                <th>Created</th>
                <th>Status</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody style="background: rgba(64, 64, 64, 0.8)">
              <tr v-for="(key, index) in Object.keys(tickets)" v-bind:key="key">
                <td>{{ index + 1 }}</td>
                <td>
                  <router-link
                    class="msg"
                    :to="{ name: 'ReplyTicket', params: { id: key } }"
                  >
                    {{ tickets[key].title }}
                  </router-link>
                </td>
                <td>
                  {{
                    moment(+tickets[key].createdAt)
                      .local()
                      .fromNow()
                  }}
                </td>
                <td>{{ tickets[key].status }}</td>
                <td>
                  {{
                    moment(+tickets[key].lastUpdateTime)
                      .local()
                      .fromNow()
                  }}
                </td>
              </tr>
              <tr v-if="(Object.keys(tickets) || []).length <= 0">
                <td colspan="5" class="center">No Tickets found</td>
              </tr>
              <tr v-else>
                <td></td>
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script
  type="text/javascript"
  src=" https://cdn.datatables.net/1.10.13/js/jquery.dataTables.min.js"
></script>
<!-- Facebook Pixel Code -->
<script>
!(function(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(
  window,
  document,
  "script",
  "https://connect.facebook.net/en_US/fbevents.js"
);
// eslint-disable-next-line no-undef
fbq("init", "261976718326827");
// eslint-disable-next-line no-undef
fbq("track", "PageView");
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=261976718326827&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<script>
// @ is an alias to /src
// import Layout from "@/views/admin/Layout.vue";
import TicketsService from "@/providers/tickets";
import firebase from "firebase";
import moment from "moment";

export default {
  name: "Tickets",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Ticket",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
   components: {},
  data() {
    return {
      moment: moment,
      userData: null,
      tickets: {},
      totalTickets: 0,
      referral: "spyowsbdsjdabasjhdgyuad/referral?/sigma101"
    };
  },
  mounted() {
    // this.dataTable = $("#tickets-table").DataTable({
    //   searching: false,
    //   paging: true,
    //   info: false,
    //   sorting: false,
    //   ordering: false,
    //   drawCallback: function() {
    //     $(
    //       ".paginate_button.next:not(.disabled)",
    //       this.api()
    //         .table()
    //         .container()
    //     ).on("click", function() {
    //       alert("next");
    //     });
    //   }
    // });
    let user = firebase.auth().currentUser;
    firebase
      .database()
      .ref(`users/${user.uid}`)
      .on("value", snapshot => {
        this.userData = snapshot.val();
      });
    // const query = firebase
    //   .database()
    //   .ref(`tablesCount/userTickets/${user.uid}`)
    //   .once("value", data => {
    //     this.totalTickets = data.val() || 0;
    //   });
    let ref = TicketsService.getMyTicketsRef(user.uid);
    if (ref && ref.once) {
      ref.once("value", data => {
        this.tickets = data.val() || {};
      });
    }
  },
  methods: {
    // updateParams(newProps) {
    //   this.serverParams = Object.assign({}, this.serverParams, newProps);
    // },
    // onPageChange(params) {
    //   console.log("this.serverParams.page < params.currentPage", this.serverParams.page < params.currentPage)
    //   if(this.serverParams.page < params.currentPage){ //previous clicked

    //   }else{ //

    //   }
      
    //   this.updateParams({ page: params.currentPage });
    //   this.loadItems();
    // },

    // onPerPageChange(params) {
    //   this.updateParams({ perPage: params.currentPerPage });
    //   this.loadItems();
    // },
    // loadItems(type) {
    //   if(type == ''){

    //   }
    // }
  }
};
</script>

<style lang="postcss" scoped>
table thead tr th {
  @apply text-left py-5 px-4 uppercase font-semibold text-sm;
}
table tbody tr {
  @apply border-b border-gray-300;
}
table tbody tr td {
  @apply text-left py-3 px-4 border-r border-gray-300;
}
table tbody tr td:last-child,
table tbody tr:last-child {
  @apply border-none;
}
table tbody tr td:not(:nth-child(2)) {
  text-align: center;
}
table tbody td a.msg {
  @apply text-custom;
}
table tbody td a.msg:hover {
  @apply underline;
}
/* table.dataTable tbody tr {
  color: rgba(64, 64, 64, 0.8) !important;
}
div#tickets-table_length,
.dataTables_length {
  color: #fff !important;
}
div#tickets-table_length select {
  color: #000;
} */
</style>
